
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/strumenti-servizi",
      function () {
        return require("private-next-pages/strumenti-servizi/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/strumenti-servizi"])
      });
    }
  